import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { apiError } from "@/lib/api";

// Customer-visible conversation. `viewer` is "customer" or "admin".
export function MessageThread({ messages = [], onSend, viewer, disabled }) {
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async (e) => {
    e.preventDefault();
    if (!body.trim()) return;
    setBusy(true);
    try { await onSend(body.trim()); setBody(""); }
    catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="message-thread">
      <div className="max-h-96 space-y-3 overflow-y-auto pr-1">
        {messages.length === 0 && <p data-testid="no-messages" className="text-sm text-kys-muted">No messages yet.</p>}
        {messages.map((m) => {
          const mine = m.sender === viewer;
          return (
            <div key={m.id} data-testid={`message-${m.id}`} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm ${mine ? "rounded-br-sm bg-kys-ink text-white" : "rounded-bl-sm bg-kys-blush text-kys-ink"}`}>
                <p className="whitespace-pre-wrap break-words">{m.body}</p>
                <p className={`mt-1 text-[10px] ${mine ? "text-white/60" : "text-kys-muted"}`}>
                  {m.sender === "admin" ? "Kys Boutique" : "Customer"} · {new Date(m.created_at).toLocaleString()}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      {!disabled && (
        <form onSubmit={send} className="mt-4 flex items-end gap-2">
          <textarea data-testid="message-input" rows={2} value={body} onChange={(e) => setBody(e.target.value)} placeholder="Write a message…"
            className="flex-1 resize-none rounded border border-kys-blush-border bg-white px-3 py-2 text-sm focus:border-kys-accent focus:outline-none" />
          <button data-testid="message-send-btn" disabled={busy || !body.trim()} aria-label="Send"
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-kys-ink text-white transition-colors hover:bg-kys-accent disabled:opacity-50">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
          </button>
        </form>
      )}
    </div>
  );
}
